import React from 'react'

import { HeadingPages } from '../../../components/HeadingPages'
import { Box } from '@chakra-ui/react'
import { useSearchParams } from 'react-router-dom'
import * as T from '../../../components/Table'
import { api } from '../../../services/api'
import { useQuery } from 'react-query'
import { ListaPedidosNegados } from './ListaPedidosNegados'
import { format } from 'date-fns'

async function getPedidosNegados() {
  const res = await api.get('/site/v2/liberacao-pedido/listar-pedidos-negados')

  return res.data.map((pedido) => ({
    ...pedido,
    data_negado: format(new Date(pedido.data_negado), "dd/MM/yyyy 'às' HH:mm"),
  }))
}

export const PedidosNegados = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  console.log(searchParams.get('teste'))

  const { data: lista, isLoading } = useQuery({
    queryKey: 'pedidos-negados',
    queryFn: getPedidosNegados,
    staleTime: 1000 * 60 * 10,
  })

  return (
    <>
      <HeadingPages name="Pedidos Negados" />

      <Box p="4">
        <T.Table>
          <T.Thead>
            <T.Tr>
              <T.Th>Numero Pedido</T.Th>
              <T.Th>Nome Cliente</T.Th>
              <T.Th>Negado em</T.Th>
              <T.Th>Data Negado</T.Th>
              <T.Th>Observação Negado</T.Th>
            </T.Tr>
          </T.Thead>
          <T.Tbody>
            {isLoading && <T.Tr>Loading...</T.Tr>}

            <ListaPedidosNegados lista={lista} />
          </T.Tbody>
        </T.Table>
      </Box>
    </>
  )
}
